import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../css/CreateAccount.css";
import { AppContext } from "../context/AppContext";
// import SaraLogo from "../assets/icons/logo.png";
import logo from "../assets/icons/dpboss.png";
import { toast } from "react-toastify";
import apiClient from "../api/apiClient";

function CreateAccount() {
  const [username, setUsername] = useState("");
  const [passwordLocal, setPasswordLocal] = useState("");
  const [confirmPassword, setConfirmPassword] =
    useState("");
  const [mpin, setMpin] = useState("");
  const [confirmMpin, setConfirmMpin] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { setUser, setPassword, mobileNo } =
    useContext(AppContext);
  const navigate = useNavigate();

  const handleNext = async () => {
    const signupMobileNo =
      mobileNo ||
      localStorage.getItem("mobileNo") ||
      localStorage.getItem("lastLoginMobileNo") ||
      "";

    if (!/^\d{10}$/.test(signupMobileNo)) {
      toast.warn("Please enter your mobile number first");
      navigate("/enter-mobile", { replace: true });
      return;
    }

    if (!username.trim()) {
      toast.warn("Please enter a username");
      return;
    }

    if (!passwordLocal.trim()) {
      toast.warn("Please enter a password");
      return;
    }

    if (passwordLocal.length < 6) {
      toast.warn(
        "Password must be at least 6 characters long"
      );
      return;
    }

    if (passwordLocal !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (mpin.length !== 4) {
      toast.warn("Please enter a valid 4-digit MPIN");
      return;
    }

    if (mpin !== confirmMpin) {
      toast.error("MPINs do not match");
      return;
    }

    setIsLoading(true);

    try {
      const registerRes = await apiClient.post("/user-register", {
        fullName: username.trim(),
        mobileNo: signupMobileNo,
        password: passwordLocal,
        password_confirmation: passwordLocal,
        security_pin: mpin,
      });

      if (registerRes.data.status === true) {
        const { accessToken, registerId } =
          registerRes.data.info;

        localStorage.removeItem("accessToken");
        localStorage.removeItem("registerId");

        localStorage.setItem(
          "accessToken",
          accessToken
        );
        localStorage.setItem(
          "registerId",
          registerId
        );
        localStorage.setItem("mobileNo", signupMobileNo);
        localStorage.setItem("lastLoginMobileNo", signupMobileNo);

        const profileRes = await apiClient.post(
          "/user-details-by-register-id",
          { registerId }
        );

        if (profileRes.data.status && profileRes.data.info) {
          const userInfo = profileRes.data.info;

          localStorage.setItem(
            "userProfile",
            JSON.stringify(userInfo)
          );
          localStorage.setItem(
            "walletBalance",
            userInfo.walletBalance
          );

          if (setUser) setUser(userInfo);
          if (setPassword) setPassword(passwordLocal);

          toast.success(
            "Account created successfully!"
          );
          navigate("/home", { replace: true });
        } else {
          toast.warn(
            "Account created, but profile load failed."
          );
          navigate("/login-with-mpin");
        }
      } else {
        toast.error(
          registerRes.data.msg ||
            "Registration failed."
        );
      }
    } catch (err) {
      console.error(
        "Register error:",
        err?.response || err
      );
      toast.error(
        err?.response?.data?.msg || "Something went wrong. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mobile-screen-wrapper">
      <div className="top-header">Sign Up</div>

      <p className="signup-subtitle">
        Create your account to get started.
      </p>

      <div className="create-account-page">
        <div className="content-box">
          <div className="logo-image-wrapper">
            <img
              src={logo}
              alt="Logo"
              className="sara-logo-img"
            />
          </div>

          <div className="form-section">
            <div className="input-box">
              <input
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) =>
                  setUsername(e.target.value)
                }
              />
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Enter password"
                value={passwordLocal}
                onChange={(e) =>
                  setPasswordLocal(e.target.value)
                }
              />
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) =>
                  setConfirmPassword(e.target.value)
                }
              />
            </div>

            <div className="input-box">
              <input
                type="password"
                inputMode="numeric"
                maxLength={4}
                placeholder="Set 4-digit MPIN"
                value={mpin}
                onChange={(e) =>
                  setMpin(e.target.value.replace(/\D/g, "").slice(0, 4))
                }
              />
            </div>

            <div className="input-box">
              <input
                type="password"
                inputMode="numeric"
                maxLength={4}
                placeholder="Confirm MPIN"
                value={confirmMpin}
                onChange={(e) =>
                  setConfirmMpin(e.target.value.replace(/\D/g, "").slice(0, 4))
                }
              />
            </div>

            <button
              className="ms-btn"
              onClick={handleNext}
              disabled={isLoading}
            >
              {isLoading
                ? "Creating Account..."
                : "Continue"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAccount;
